import useOnlineStatus from '@/hooks/useOnlineStatus';
import styles from './ConnectivityIndicator.module.scss';

interface IConnectivityIndicatorProps {
  showLabel?: boolean;
  className?: string;
}

function ConnectivityIndicator({ showLabel, className = '' }: IConnectivityIndicatorProps) {
  const isOnline = useOnlineStatus();

  if (showLabel)
    return (
      <div className={className}>
        <span className={`${styles.indicator} ${isOnline ? styles.online : styles.offline}`} title={isOnline ? 'Online' : 'Offline'} />
        <span>{isOnline ? 'Online' : 'Offline'}</span>
      </div>
    );

  return <span className={`${styles.indicator} ${isOnline ? styles.online : styles.offline}`} title={isOnline ? 'Online' : 'Offline'} />;
}

export default ConnectivityIndicator;
